export const calculateMisdemeanor = (misd_checked_number, additions) => {
    const checkedNumber = parseInt(misd_checked_number - 1);
    if(checkedNumber < 0) return 0;

    const value = parseInt(additions.misd) + (checkedNumber * parseInt(additions.misd_extra))
    return Number.isNaN(value) ? 0 : value;
}